import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { DialogAudkenningConfirmExtendToken } from 'app/dialogs/audkenning/confirm-extend-token/dialog-audkenning-confirm-extend-token';
import { DialogAudkennigInnskra } from 'app/dialogs/audkenning/innskra/dialog-audkenning-innskra';
import { AuthService } from 'app/fuse-template/core/auth/auth.service';
import { clone } from 'app/helpers/clone';
import { ExposedReadUserDetailsRes } from 'app/interfaces/responses/Exposed/exposedReadUserDetailsRes';
import { LsrauthService } from 'app/services/api/lsrauth/lsrauth.service';
import { FormService } from 'app/services/system/form/form.service';
import { LoaderService } from 'app/services/system/loader/loader.service';
import { environment } from 'environments/environment';
import { asapScheduler, observeOn } from 'rxjs';
import { filter } from 'rxjs/operators';
declare var gtag;

@Component({
    selector: 'app-root',
    animations: [trigger('fadeInOut', [transition(':leave', [animate(300, style({ opacity: 0 }))])])],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    userDetails: ExposedReadUserDetailsRes = null;

    loader = false;

    testEnvironment = environment.environment === 'test' ? 'dev' : environment.environment === 'release' ? 'release' : null;

    /**
     * Constructor
     */
    constructor(
        public dialog: MatDialog,
        public authService: AuthService,
        private router: Router,
        private formService: FormService,
        private loaderService: LoaderService,
        public lsrauthService: LsrauthService,
        private changeDetector: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.updateTokenOnActive();

        this.loaderService.loader.pipe(observeOn(asapScheduler)).subscribe((loader) => {
            this.loader = loader;
            this.changeDetector.markForCheck();
        });
        this.lsrauthService.userDetails.subscribe((userDetails) => (this.userDetails = userDetails));
    }

    ngAfterViewInit(): void {
        this.checkTokenIsAboutToExpire();
        if (environment.environment === 'production') {
            this.GA();
            this.SiteImprove();
        }
    }

    GA() {
        // Google Analytics
        const navEndEvents = this.router.events.pipe(filter((event) => event instanceof NavigationEnd));
        navEndEvents.subscribe((event: NavigationEnd) => {
            gtag('config', environment.googleAnalyticsGtag, {
                page_path: event.urlAfterRedirects,
            });
        });
    }

    SiteImprove() {
        let node = document.createElement('script');
        node.src = 'https://siteimproveanalytics.com/js/siteanalyze_6083826.js';
        node.type = 'text/javascript';
        node.async = true;
        document.getElementsByTagName('head')[0].appendChild(node);
    }

    //#region Check for token lifetime

    hasTabPrompted = false;
    hasTabPromptedSecond = false;
    _keepAuthSessionDialogRef: any;
    _innskraningAuthSessionDialogRef: any;

    checkTokenIsAboutToExpire() {
        let _this = this;
        var intervalId = window.setInterval(function () {
            if (_this.userDetails != null) {
                if (_this.authService._authenticated && _this.checkUrl()) {
                    let dateNow = new Date();

                    let promptWarning = new Date(clone(_this.authService._lastTokenTime));
                    promptWarning.setMinutes(promptWarning.getMinutes() + environment.refreshTokenTimeWarning);

                    let signoutTime = new Date(clone(_this.authService._lastTokenTime));
                    signoutTime.setMinutes(signoutTime.getMinutes() + environment.refreshTokenTime);

                    // Leyfi notanda að innskrá sig aftur með modal ef auðkenni hans/hennar er runnið út.
                    if (dateNow > signoutTime) {
                        if (!_this.hasTabPromptedSecond) {
                            _this.hasTabPromptedSecond = true;
                            try {
                                _this._keepAuthSessionDialogRef.close();
                            } catch {}

                            _this.formService.clearAllDirtyForms();
                            _this._innskraningAuthSessionDialogRef = _this.dialog.open(DialogAudkennigInnskra, {
                                restoreFocus: false,
                                autoFocus: false,
                                maxWidth: '440px',
                            });

                            _this._innskraningAuthSessionDialogRef.afterClosed().subscribe((result) => {
                                _this.hasTabPromptedSecond = false;
                            });
                        }
                    }

                    // Birti count-down þegar auðkenni notanda er við það að renna út.
                    if (dateNow > promptWarning) {
                        if (!_this.hasTabPrompted && !_this.hasTabPromptedSecond) {
                            _this.hasTabPrompted = true;
                            _this.openSignOutCheckExtendedDialog();
                        }
                    } else {
                        if (_this._keepAuthSessionDialogRef) {
                            _this._keepAuthSessionDialogRef.close();
                        }
                        if (_this._innskraningAuthSessionDialogRef) {
                            _this._innskraningAuthSessionDialogRef.close();
                        }
                    }
                }
            }
        }, 1000);
    }

    openSignOutCheckExtendedDialog() {
        this._keepAuthSessionDialogRef = this.dialog.open(DialogAudkenningConfirmExtendToken, {
            restoreFocus: false,
            autoFocus: false,
            width: '600px',
        });

        this._keepAuthSessionDialogRef.afterClosed().subscribe((result) => {
            this.hasTabPrompted = false;
        });
    }

    updateTokenOnActive() {
        this.router.events.pipe(filter((event: any) => event instanceof NavigationEnd)).subscribe((event) => {
            if (this.authService._authenticated && this.checkUrl() && event.url != '/utskra') {
                this.authService.updateToken();
            }
        });
    }

    // URLS which should not be checked are listed within this function
    // The function returns true if the URL should be checked.
    checkUrl() {
        if (window.location.href.indexOf('stadfesting-netfangs') > -1 || window.location.href.indexOf('innskra') > -1) {
            return false;
        } else {
            return true;
        }
    }

    //#endregion
}
